export default "__VITE_ASSET__Iz2VQ9jn__"